(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("tabbar", [], factory);
	else if(typeof exports === 'object')
		exports["tabbar"] = factory();
	else
		root["tabbar"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 